import { render, staticRenderFns } from "./KtvSmsVerificationStatusAlertMessage.vue?vue&type=template&id=c4da619e"
import script from "./KtvSmsVerificationStatusAlertMessage.vue?vue&type=script&lang=js"
export * from "./KtvSmsVerificationStatusAlertMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports